import { QueryClient, queryOptions } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const webhookDetailQuery = (companyId: string, gameId: string, webhookId: string) =>
  queryOptions({
    queryKey: [gameId, 'webhooks', webhookId],
    queryFn: () => dashboardClient.v1.getWebhook(companyId, gameId, webhookId).then(r => r.data),
  })

export const invalidateWebhookDetailQuery = async (ql: QueryClient, gameId: string, webhookId: string) => {
  await ql.invalidateQueries({ queryKey: [gameId, 'webhooks', webhookId] })
}
